module.exports = __webpack_public_path__ + "img/money-2.f0799f89.png";